/* eslint-disable no-shadow, no-console */
import { Component, OnInit, OnDestroy, PLATFORM_ID, Renderer2, Inject } from '@angular/core';
import { Field, LayoutServiceContextData } from '@sitecore-jss/sitecore-jss-angular';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { JssState } from '../../JssState';
import { PageMetaComponentBase } from '../../page-meta-component-base';
import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { environment } from '../../../environments/environment';
import { DynamicScriptLoaderService } from '../../services/dynamic-script-loader.service';

enum LayoutState {
  Layout,
  NotFound,
  Error
}

interface RouteFields {
  [name: string]: unknown;
  pageTitle: Field<string>;
}


@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
})
export class LayoutComponent extends PageMetaComponentBase implements OnInit, OnDestroy {
  state: LayoutState;
  LayoutState = LayoutState;
  subscription: Subscription;
  errorContextData: LayoutServiceContextData;
  _isPlatformServer: boolean = false;
  _isPlatformBrowser: boolean = false;
  mainLoaded:boolean;
  //dynamicScriptLoader: any;

  constructor(
    @Inject(PLATFORM_ID) public readonly platformId: string,
    @Inject(DOCUMENT) public document: Document,
    private activatedRoute: ActivatedRoute,
    public renderer: Renderer2,
    private dynamicScriptLoader: DynamicScriptLoaderService,

  ) {
    super(renderer, platformId, document);
  }

  ngOnInit() {
    this._isPlatformServer = isPlatformServer(this.platformId);
    this._isPlatformBrowser = isPlatformBrowser(this.platformId);


    // route data is populated by the JssRouteResolver
    this.subscription = this.activatedRoute.data.subscribe((data: { jssState: JssState<RouteFields> }) => {
      if (!data.jssState) {
        this.state = LayoutState.NotFound;
        return;
      }

      if(!this._isPlatformServer && this._isPlatformBrowser) {
        if(environment.cookieDomain){
          let srccookie = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
          if (!this.document.querySelector(`script[src="${srccookie}"]`)) {
            this.dynamicScriptLoader.loadScript(srccookie, "data-domain-script", environment.cookieDomain, "data-document-language", "true");
          }
          let srccookieAutoBlock = "https://cdn.cookielaw.org/consent/"+environment.cookieDomain+"/OtAutoBlock.js";
          if (!this.document.querySelector(`script[src="${srccookieAutoBlock}"]`)) {
            this.dynamicScriptLoader.loadScript(srccookieAutoBlock);
          }
          let inlineScript = "function OptanonWrapper() { }";
          if (!this.scriptSrcOrContentExists(null, inlineScript)) {
            this.dynamicScriptLoader.loadScriptInline(inlineScript,"head");
          }
        }
      }
      if (data.jssState.sitecore && data.jssState.sitecore.route) {
        this.route = data.jssState.sitecore.route;
        this.setPageTheme(this.route.fields);
        this.mainLoaded = false;
        if (data.jssState.sitecore.route.name != "*") {
          super.setState(data.jssState);
          super.ngOnInit();
        }else{
          super.setLanguage(data.jssState.language);
        }

        if(data.jssState.language == "en")
        {
          this.document.documentElement.setAttribute("lang", "en");
        }
        else 
        {
          this.document.documentElement.setAttribute("lang", "el");
        }
        
        //this.setPageTitleMetadata(this.route.fields);
        this.state = LayoutState.Layout;              

      }

      if (data.jssState.routeFetchError) {
        if (data.jssState.routeFetchError.status >= 400 && data.jssState.routeFetchError.status < 500) {
          this.state = LayoutState.NotFound;
        } else {
          this.state = LayoutState.Error;
        }

        this.errorContextData = data.jssState.routeFetchError.data && data.jssState.routeFetchError.data.sitecore;
      }
    
      const googleAnalyticsFileGrowthTracker = (data?.jssState?.sitecore?.route?.fields?.GrowthTracker as any)?.value?.src;
      if (googleAnalyticsFileGrowthTracker && this.renderer) {
        const fullSrcUrl = new URL(googleAnalyticsFileGrowthTracker, window.location.origin).href;

        const isScriptAlreadyLoaded = Array.from(document.head.getElementsByTagName('script')).some(
          (script) => script.src === fullSrcUrl
        );

      if (!isScriptAlreadyLoaded) {
        const script = this.renderer.createElement('script');
        script.type = 'text/javascript';
        script.src = fullSrcUrl;
        this.renderer.appendChild(document.head, script);
      }
    }
    const googleAnalyticsFileGrowthTracking = (data?.jssState?.sitecore?.route?.fields?.GrowthTracking as any)?.value?.src;
      if (googleAnalyticsFileGrowthTracking && this.renderer) {
        const fullSrcUrl = new URL(googleAnalyticsFileGrowthTracking, window.location.origin).href;

        const isScriptAlreadyLoaded = Array.from(document.head.getElementsByTagName('script')).some(
          (script) => script.src === fullSrcUrl
        );

      if (!isScriptAlreadyLoaded) {
        const script = this.renderer.createElement('script');
        script.type = 'text/javascript';
        script.src = fullSrcUrl;
        this.renderer.appendChild(document.head, script);
      }
    }
    
    });
  }

  scriptSrcOrContentExists(scriptSrc : any, scriptContent: any) {
    if(!this._isPlatformServer && this._isPlatformBrowser) {
      // Check for external scripts by src attribute
      if (scriptSrc && this.document.querySelector(`script[src="${scriptSrc}"]`)) {
          return true;
      }
      // Check for inline scripts by content
      if (scriptContent) {
          const scripts  = this.document.querySelectorAll('script') as any;
          if (scripts) {
          if (scripts.length > 1) {
            for (let script of scripts) {
              if (script.textContent.includes(scriptContent)) {
                  return true;
              }
            }
          }
        }
      }
    }
    return false;
  }
  ngOnDestroy() {
    // important to unsubscribe when the component is destroyed
    this.subscription.unsubscribe();
  }

  setPageTitleMetadata(routeFields: RouteFields) {
    // set page title, if it exists
    if (routeFields && routeFields.pageTitle) {
      this.meta.setTitle(routeFields.pageTitle.value || 'Page');
    }
  }

  onPlaceholderLoaded(placeholderName: string) {
    // you may optionally hook to the loaded event for a placeholder,
    // which can be useful for analytics and other DOM-based things that need to know when a placeholder's content is available.
    console.debug(`layout.component.ts: placeholder component fired loaded event for the ${placeholderName} placeholder`);
  }

  setPageTheme(routeFields: RouteFields){
    
    if((routeFields.Theme as any).value){
      this.document.documentElement.setAttribute("data-sector", (routeFields.Theme as any).value.toLowerCase());
    }else{
      this.document.documentElement.setAttribute("data-sector", "default");
    }
  }

}